module.exports = new __parcel__URL__("Wetlands_image_v2_rs.72e4d43f.png").toString();